<template>
  <div>
    <div class="records-information row">
      <div class="col-md-12">
        <p v-if="recordCount">
          <span class="highlight">
            {{recordCount}} {{ $tc('records.video', records.length >= 2 ? 2 : 1) }}
          </span>
          {{ $tc('records.has_been_recorded', records.length >= 2 ? 2 : 1) }}
          <span v-if="diversityTree">
            <br />
            <a href="#" title="show dendrogram" @click.prevent="showTree = !showTree">
              <img style="height: 16px; cursor: pointer; opacity:0.7;"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII="
              alt="dendrogram"
              />
            </a>
          </span>
        </p>
      </div>
    <transition name="fade">
      <dendrogram :root="diversityTree" v-if="showTree" class="dendrogram"></dendrogram>
    </transition>
    </div>
    <div class="records row">
      <div v-show="loading && !records.length" class="loading-indicator center-block"></div>
      <p v-if="records.length === 0 && !loading" class="empty">{{ $t("records.none_available") }}</p>
      <transition name="fade" mode="out-in">
        <div v-if="newRecordsCount > 0" class="alert new-record-avaible">
          <span class="badge">{{ newRecordsCount }}</span>
          {{ $tc('records.new_available', newRecordsCount >= 2 ? 2 : 1) }}
          <a href="#" @click.prevent.stop="swapInNewRecords()">{{ $tc('records.click_here_to_refresh') }}</a>
        </div>
      </transition>
      <marker-tags-selector
        :markerId="markerId"
        @tags-selected="handleTagsSelected"
      />
      <lmr-city-report-filter
        v-if="isLmrConsumer"
        v-model="recordFilters.lmr_cities"
        @change="handleLmrCitySelected"
      />
      <inappropriate-filter
        v-model="recordFilters.inappropriate"
        @change="fetchRecordCoords(true)"
      />
      <lmr-category-filter
        v-if="isLmrConsumer"
        v-model="recordFilters.lmr_category"
        @change="fetchRecordCoords(true)"
      />
      <v-tabs fixed-tabs slider-color="#ff2d55" v-model="activeTab" @change="tabSelected">
        <v-tab>Approved</v-tab>
        <v-tab>Deleted</v-tab>
      </v-tabs>

      <!-- Marker Map -->
      <div class="row">
      <template v-if="markerId">
        <div class="col-md-12 flex-container flex-stretch" id="marker-map-container" style="padding-top: 15px">
          <marker-map style="flex: 1; position: relative; z-index: 1"
            :image_coords="image_coords"
            :video_coords="video_coords"
            @clicked-marker="handleClickedMarker"
            @map-moved="handleMapMoved"

          ></marker-map>
        </div>
      </template>
      </div>
      <div class="row">
      <v-radio-group v-if="marker" v-model="ordering">
        <v-radio
          v-for="item in orderingItems"
          :key="item.key"
          :label="item.label"
          :value="item.key"
          @change="changeOrdering"
        ></v-radio>
      </v-radio-group>
      </div>


      <!-- Marker records list: -->
      <records-list
        :records="records"
        :marker="marker"
        @delete-record="handleRecordDelete"
        @restore-record="handleRecordRestore"
        @mark-record-relevance="markRecordRelevance"
        @clicked-record="showRecordDetails"
        />
      <div class="row record-details">
        <record-details
          :record="selectedRecord"
          :marker-id="markerId"
          v-if="selectedRecord"
          @clicked-similar-record="showRecordDetails"
          @close="selectedRecord = null">
        </record-details>
      </div>
      <div v-show="!loading && records.length">
        <v-pagination
          v-model="recordsPage"
          @input="fetchRecords('VIDEO')"
          :length="calculateAmountPages('VIDEO')"
          :total-visible="10"
        ></v-pagination>
      </div>
    </div>
    <div v-if="imageRecords.length > 0">
      <div>
        <h2>Images</h2>
        <div class="row record-details">
          <records-list
            :records="imageRecords"
            :marker="marker"
            @delete-record="handleRecordDelete"
            @restore-record="handleRecordRestore"
            @mark-record-relevance="markRecordRelevance"
            @clicked-record="showRecordDetails"
            />
        </div>
      </div>
      <div v-show="!image_loading">
        <v-pagination
          v-model="imagesPage"
          @input="fetchRecords('IMAGE')"
          :length="calculateAmountPages('IMAGE')"
          :total-visible="10"
        ></v-pagination>
      </div>
    </div>
    <div class="records-information related-records row">
      <div class="col-md-12">
        <div v-if="relatedRecords.length > 0">
          <h3>{{ $tc('records.related_streams_title') }}</h3>
          <p class="help-block">
            <em>
              {{ $tc('records.related_streams_help') }}
            </em>
          </p>
        </div>
      </div>
    </div>
    <div class="records related-records row">
      <!-- Marker related VODs list: -->
      <records-list :records="relatedRecords" :read-only="true"></records-list>
    </div>
  </div>
</template>

<script>
// Marker records component
// Retrieve and manage the state of the list of vods for a marker
// (loading, auto-refreshing, responding to events, etc.)
// The rendering of the actual records is handled by sub-components
// IDEA: improve the auto-refreshing behavior to avoid polling the vod endpoint

import MarkerMap from './MarkerMap.vue'
import RecordsList from './record/RecordsList.vue'
import RecordRepository from '../../repositories/RecordRepository.js'
import Dendrogram from './MarkerDendrogram.vue'
import RecordDetails from './record/RecordDetails.vue'
import events from '../../services/events'
import MarkerTagsSelector from './record/MarkerTagsSelector'
import InappropriateFilter from './record/InappropriateFilter'
import LmrCategoryFilter from './record/LmrCategoryFilter'
import LmrCityReportFilter from './record/LmrCityReportFilter'
import { mapGetters } from 'vuex'

export default {
  components: {
    RecordsList,
    RecordDetails,
    Dendrogram,
    MarkerTagsSelector,
    MarkerMap,
    InappropriateFilter,
    LmrCategoryFilter,
    LmrCityReportFilter,
  },
  props: [
    'marker'
  ],
  data: function () {
    return {
      records: [],
      video_coords: [],
      image_coords: [],
      filteredIds: [],
      filteredImageIds: [],
      imageRecords: [],
      newRecords: [],
      newRecordsCount: 0,
      relatedRecords: [],
      diversityTree: null,
      showTree: false,
      timer: '',
      loading: true,
      selectedRecord: null,
      recordFilters: {
        tags: [],
        inappropriate: 'hide',
        // special filters for LMR consumer
        lmr_category: '',
        lmr_cities: [],
      },
      activeTab: 0,
      ordering: 'default',
      orderingItems: [
        // {'key': 'id', 'label': 'Sort by default'},
        {'key': 'diversity', 'label': 'Sort by Diversity'},
        {'key': 'consistency', 'label': 'Sort by Consistency'},
        {'key': 'relevance', 'label': 'Sort by Relevance'}
      ],
      pageSize: 30,
      recordsPage: 1,
      imagesPage: 1,
      recordCount: 0
    }
  },
  mounted: function () {
    this.setup()
  },
  methods: {
    // fetch initial data and setup auto-refresh
    setup () {
      // this.setupInterval()
      // this.fetchRecords('VIDEO')
      // this.fetchRecords('IMAGE')
      this.fetchRecordCoords()
      this.fetchRelatedRecords()
      this.fetchRecordsDiversity()
    },
    setupInterval () {
      clearInterval(this.timer)
      this.timer = setInterval(this.updateRecords.bind(this), 30000)
    },
    handleRecordDelete (record, recordType) {
      // handle record delete confirmation, submit to backend and reload records list
      RecordRepository.deleteRecord(this.markerId, record).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleRecordRestore (record, recordType) {
      RecordRepository.restoreRecord(this.markerId, record).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleTagsSelected (tags) {
      this.filteredIds = []
      this.filteredImageIds = []
      this.recordFilters.tags = tags
      // this.fetchRecords('VIDEO')
      // this.fetchRecords('IMAGE')
      this.fetchRecordCoords()
    },
    handleLmrCitySelected (cities) {
      this.recordFilters.lmr_cities = cities
      this.fetchRecordCoords(true)
    },
    changeOrdering (ordering) {
      this.records = this.records.sort((a, b) => {
        return (b.mldata[ordering] || 0) - (a.mldata[ordering] || 0)
      })
    },
    fetchRecordsFromRepository (recordType, page) {
      return RecordRepository.fetchMarkerRecords(
        this.marker,
        page,
        this.pageSize,
        this.recordFilters,
        recordType,
        this.activeTab
        )
    },
    updateRecords () {
      this.fetchRecordsFromRepository('VIDEO', this.recordsPage).then((records) => {
        // comparing sets
        var oldIds = this.records.map(function (record) {
          return record.id
        })
        var newRecordsCount = records.filter(function (record) {
          return oldIds.indexOf(record.id) < 0
        }).length
        if (newRecordsCount > 0) {
          if (this.records.length === 0) {
            // if we had no videos previously, just load up the new one(s)
            this.records = records
          } else if (this.records.length > 0) {
            // if we had videos loaded before, store the new ones in a staging area
            this.newRecords = records
            this.newRecordsCount = newRecordsCount
          }
        }
      })
    },
    swapInNewRecords () {
      this.records = this.newRecords.splice(0, this.newRecords.length)
      this.newRecords.length = 0 // clear the array
      this.newRecordsCount = 0
    },
    fetchRecords (recordType) {
      this.loading = true
      let page = recordType === 'VIDEO' ? this.recordsPage : this.imagesPage
      this.fetchRecordsByIds(recordType, page).then((records) => {
        this.loading = false
        this.setRecords(recordType, records)
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
    },
    fetchRecordsByIds (recordType, page) {
      var offset
      var ids = []
      if (recordType === 'VIDEO' && this.filteredIds) {
        offset = (page - 1) * this.pageSize
        ids = this.filteredIds.slice(offset, offset + this.pageSize)
      } else if (recordType === 'IMAGE' && this.filteredImageIds) {
        offset = (page - 1) * this.pageSize
        ids = this.filteredImageIds.slice(offset, offset + this.pageSize)
      }
      if (ids.length) {
        return RecordRepository.fetchMarkerRecordsByIds(
          this.marker,
          recordType,
          ids)
      }
      return []
      // return RecordRepository.fetchMarkerRecordsByIds(this.markerId, ids)
    },
    fetchRecordCoords (onlyVideo = false) {
      if (!this.markerId) {
        return
      }
      this.loading = true
      this.video_coords = []

      RecordRepository.fetchMarkerRecordCoords(
        this.markerId, this.recordFilters, 'VIDEO', this.activeTab
      ).then((coords) => {
        this.loading = false
        this.video_coords = coords
        this.recordCount = this.video_coords.length
        this.records = []
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })

      if (onlyVideo) return

      this.image_loading = true
      this.image_coords = []
      RecordRepository.fetchMarkerRecordCoords(
        this.markerId, this.recordFilters, 'IMAGE', this.activeTab
      ).then((coords) => {
        this.image_loading = false
        this.image_coords = coords
        this.imageCount = this.image_coords.length
        this.imageRecords = []
      }, (error) => {
        this.image_loading = false
        events.emit('error', error)
      })
    },
    setRecords (recordType, records) {
      if (recordType === 'VIDEO') {
        this.records = records
      } else {
        this.imageRecords = records
      }
    },
    fetchRelatedRecords () {
      if (!this.markerId) {
        return
      }
      RecordRepository.fetchMarkerRelatedRecords(this.markerId, this.activeTab)
        .then(records => { this.relatedRecords = records })
    },
    fetchRecordsDiversity () {
      if (!this.markerId) {
        return
      }
      RecordRepository.fetchMarkerRecordsDiversityTree(this.markerId).then((response) => {
        this.diversityTree = response.tree
      })
    },
    markRecordRelevance (record, relevance, recordType) {
      const r = this.getRecords(recordType).find((r) => { return r.id === record.id })
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance
      }
      RecordRepository.patchRecordRelevance(this.markerId, record, relevance)
      .catch((error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    getRecords (recordType) {
      const typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      }
      return typeMapping[recordType]
    },
    tabSelected () {
      this.filteredIds = []
      this.filteredImageIds = []
      this.records = []
      this.imageRecords = []
      // this.fetchRecords('VIDEO')
      // this.fetchRecords('IMAGE')
      this.fetchRecordCoords()
      this.fetchRelatedRecords()
    },
    calculateAmountPages (recordType) {
      if (recordType === 'VIDEO') {
        return Math.ceil(this.recordCount / this.pageSize) || 1
      } else {
        return Math.ceil(this.imageCount / this.pageSize) || 1
      }
    },
    showRecordDetails (record) {
      this.selectedRecord = record
    },
    handleClickedMarker (id) {
      RecordRepository.fetchMarkerRecordsByIds(
        this.marker,
        '',
        [id]).then((record) => {
          this.showRecordDetails(record[0])
        })
    },
    handleMapMoved (idsV, idsI) {
      if (!this.compareArrays(idsV, this.filteredIds)) {
        this.filteredIds = idsV
        this.recordsPage = 1
        this.recordCount = this.filteredIds.length
        this.records = []
        if (idsV.length) {
          this.fetchRecords('VIDEO')
        }
      }
      if (!this.compareArrays(idsI, this.filteredImageIds)) {
        this.filteredImageIds = idsI
        this.imagesPage = 1
        this.imageCount = this.filteredImageIds.length
        this.imageRecords = []
        if (idsI.length) {
          this.fetchRecords('IMAGE')
        }
      }
      // this.fetchRecords('IMAGE')
    },
    compareArrays (arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false
      }
      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false
        }
      }
      return true
    }
  }, // methods
  computed: {
    ...mapGetters(['isLmrConsumer']),
    markerId () {
      return this.marker && this.marker.id
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
}

</script>



// WEBPACK FOOTER //
// MarkerRecords.vue?036301be